/* unplugin-vue-components disabled */import { render } from "./FooterBanner.vue?vue&type=template&id=277297fd&ts=true"
import script from "./FooterBanner.vue?vue&type=script&lang=ts"
export * from "./FooterBanner.vue?vue&type=script&lang=ts"

import "./FooterBanner.vue?vue&type=style&index=0&id=277297fd&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__